/* eslint-disable @typescript-eslint/no-var-requires */

import { createGlobalStyle } from 'styled-components'

const ComfortaaLightWoff2 = require('./assets/Comfortaa/Comfortaa-Light.woff2')
const ComfortaaBoldWoff2 = require('./assets/Comfortaa/Comfortaa-Bold.woff2')
const PraterSansWoff2 = require('./assets/PraterSans/PraterSans-Regular.woff2')
const RobotoBoldWoff2 = require('./assets/Roboto/Roboto-Bold.woff2')
const RobotoRegularWoff2 = require('./assets/Roboto/Roboto-Regular.woff2')
const RobotoLightWoff2 = require('./assets/Roboto/Roboto-Light.woff2')

export const FontFamily = {
  comfortaa: 'Comfortaa',
  praterSans: 'PraterSans',
  roboto: 'Roboto',
}

export default createGlobalStyle`
  @font-face {
    font-family: ${FontFamily.comfortaa};
    font-style: normal;
    font-weight: 300;
    src: url(${ComfortaaLightWoff2}) format('woff2');
  }

  @font-face {
    font-family: ${FontFamily.comfortaa};
    font-style: normal;
    font-weight: 700;
    src: url(${ComfortaaBoldWoff2}) format('woff2');
  }

  @font-face {
    font-family: ${FontFamily.praterSans};
    font-style: normal;
    font-weight: 400;
    src: url(${PraterSansWoff2}) format('woff2');
  }

  @font-face {
    font-family: ${FontFamily.roboto};
    font-style: normal;
    font-weight: 300;
    src: url(${RobotoLightWoff2}) format('woff2');
  }

  @font-face {
    font-family: ${FontFamily.roboto};
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoRegularWoff2}) format('woff2');
  }

  @font-face {
    font-family: ${FontFamily.roboto};
    font-style: normal;
    font-weight: 700;
    src: url(${RobotoBoldWoff2}) format('woff2');
  }
`
